import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';

const PrintTitle = ({ title, date }) => {
    return (
        <div
            className="print-visible"
            style={{ textAlign: 'center', clear: 'both' }}
        >
            <Typography variant="h6">{title}</Typography>
            
            {date !== undefined && (
                <div style={{ textAlign: 'right', paddingRight: 8 }}>
                    Date: {date}
                </div>
            )}
        </div>
    );
};
export default PrintTitle;
